import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell, Typography, IconButton, makeStyles } from "@material-ui/core";
import ListIcon from '@material-ui/icons/List';
import CustomSwitch from "../Common/CustomSwitch";
import NoData from './../Common/NoDataRow';
import { TooltipTop } from './../Common/CustomTooltips';
import t from "../../languages/pl";

const useStyles = makeStyles(theme => ({
    cell: {
        paddingLeft: theme.spacing(1),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        textAlign: "center",
    },
}));

const GroupRow = ({ data, onShowList, onChange }) => {
    const classes = useStyles();

    const handleChange = (data, e) => {
        onChange && onChange(data, e);
    };

    const printTable = (data) => {
        if (!Array.isArray(data) || data.length === 0)
            return <NoData colSpan={8} />;
        return data.map(row => {
            return (
                <React.Fragment key={row.grupa_id}>
                    <TableRow>
                        <TableCell className={classes.cell}>
                            <Typography variant="body1">
                                {row.grupa_nazwa}
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.cell}>
                            <Typography variant="body1">
                                {row.grupa_opis}
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.cell}>
                            <TooltipTop title={row.mpr ? t.turnedOn : t.turnedOff}>
                            <CustomSwitch
                                checked={row.mpr}
                                name="mpr"
                                onChange={handleChange.bind(this, row)}
                            />
                            </TooltipTop>
                        </TableCell>
                        <TableCell className={classes.cell}>
                            <TooltipTop title={row.mpp ? t.turnedOn : t.turnedOff}>
                            <CustomSwitch
                                checked={row.mpp}
                                name="mpp"
                                onChange={handleChange.bind(this, row)}
                            />
                            </TooltipTop>
                        </TableCell>
                        <TableCell className={classes.cell}>
                            <TooltipTop title={row.mnu ? t.turnedOn : t.turnedOff}>
                            <CustomSwitch
                                checked={row.mnu}
                                name="mnu"
                                onChange={handleChange.bind(this, row)}
                            />
                            </TooltipTop>
                        </TableCell>
                        <TableCell className={classes.cell}>
                            <TooltipTop title={row.mprpu ? t.turnedOn : t.turnedOff}>
                            <CustomSwitch
                                checked={row.mprpu}
                                name="mprpu"
                                onChange={handleChange.bind(this, row)}
                            />
                            </TooltipTop>
                        </TableCell>
                        <TableCell className={classes.cell}>
                            <TooltipTop title={row.rezerwa ? t.turnedOn : t.turnedOff}>
                            <CustomSwitch
                                checked={row.rezerwa}
                                name="rezerwa"
                                onChange={handleChange.bind(this, row)}
                            />
                            </TooltipTop>
                        </TableCell>
                        <TableCell className={classes.cell}>
                            <TooltipTop title={row.przekroczenie_granicy ? t.turnedOn : t.turnedOff}>
                                <CustomSwitch
                                    checked={row.przekroczenie_granicy}
                                    name="przekroczenie_granicy"
                                    onChange={handleChange.bind(this, row)}
                                />
                            </TooltipTop>
                        </TableCell>

                        <TableCell className={classes.cell}>
                            <Typography variant="body1">
                                {row.grupa_liczba_aut}
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.cell}>
                            <IconButton
                                onClick={() => onShowList(row.grupa_id)}
                            >
                                <ListIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                </React.Fragment>
            );
        });
    };

    return (
        <React.Fragment>
            {printTable(data)}
        </React.Fragment>
    );
};

GroupRow.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.array,
    onShowList: PropTypes.func,
    onDelete: PropTypes.func,
    onChange: PropTypes.func
};

export default (GroupRow);
